import React from 'react';
import PropTypes from 'prop-types';
import { MetricsElement } from 'react-metrics';

import Link from '../../../shared/components/hyperlink';

import './css/sub-menu.less';

export function SubMenu({ title, items, closeMenu }) {
    return (
        <div role="navigation" className="submenu-links">
            <div className="title">{title}</div>
            <MetricsElement element="ul" role="menu">
                {items.map((item, itemKey) => (
                    <li key={itemKey} role="menuitem" onClick={closeMenu}>
                        <Link
                            data-metrics-event-name="linkClick"
                            data-metrics-event={item.analyticsLinkType}
                            data-metrics-link-id={item.analyticsLinkID}
                            data-metrics-link-placement={"header"}
                            to={item.link}
                            
                        >
                            {item.name}
                        </Link>
                    </li>
                ))}
            </MetricsElement>
        </div>
    );
}

SubMenu.propTypes = {
    title: PropTypes.string.isRequired,
    items: PropTypes.array.isRequired,
    closeMenu: PropTypes.func.isRequired,
};

export default SubMenu;
